import { ActivityPacing } from '@showbie-socrative/socrative-utils';

import { RoomTypes } from '~analytics/types';
import { LaunchRoute } from '~teacher/launchv2/context/LaunchModalContext';

import { sendLaunchQuizEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface LaunchQuizEventAdapterParams {
  settings: any;
  isRosteredRoom: boolean;
  launchRoute: LaunchRoute;
  workspaceData?: { workspace_id: string; workspace_quiz_id: string };
}

export class LaunchQuizEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-quiz';
  protected amplitudeEventFunction = sendLaunchQuizEvent;

  constructor({
    settings,
    isRosteredRoom,
    launchRoute,
    workspaceData = null,
  }: LaunchQuizEventAdapterParams) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      let deliveryMethod = 'instant_feedback';

      if (settings.pacing === ActivityPacing.Teacher)
        deliveryMethod = 'teacher_paced';
      if (settings.allow_student_nav || settings.allowStudentNav)
        deliveryMethod = 'open_navigation';

      this.eventData = {
        room_type: roomType,
        delivery_method: deliveryMethod,
        activity_require_names: settings.require_names || settings.requireNames,
        activity_shuffle_questions:
          settings.random_questions || settings.randomQuestions,
        activity_shuffle_answers:
          settings.random_answers || settings.randomAnswers,
        activity_show_question_feedback:
          settings.show_feedback || settings.showFeedback,
        activity_show_final_score:
          settings.show_results || settings.showResults,
        activity_one_attempt: settings.one_attempt || settings.oneAttempt,
        launch_route: launchRoute,
      };

      if (workspaceData) {
        this.eventData['workspace_id'] = workspaceData.workspace_id;
        this.eventData['workspace_quiz_id'] = workspaceData.workspace_quiz_id;
      }
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
